import UnitBase from "../unit/UnitBase";

class PercentUnit extends UnitBase {
    constructor() {
        super(null, "Percent", "%");
    }
}


export default PercentUnit;
